import { jsx as _jsx } from "react/jsx-runtime";
import { Button, Panel, TagsInput, useToast } from "@vertesia/ui/core";
import { useUserSession } from "@vertesia/ui/session";
import { useEffect, useState } from "react";
import { useUITranslation } from '../../../i18n/index.js';
export function SharedPropsEditor({ collection }) {
    const { client } = useUserSession();
    const { t } = useUITranslation();
    const [colType, setColType] = useState(undefined);
    const [sharedProps, setSharedProps] = useState(collection.shared_properties || []);
    const toast = useToast();
    useEffect(() => {
        if (collection.type?.id) {
            client.store.types.retrieve(collection.type.id).then(setColType);
        }
    }, [collection.type?.id]);
    const options = colType ? Object.keys(colType.object_schema?.properties || {}) : [];
    const onSelect = (selected) => {
        setSharedProps(selected);
    };
    const onSave = () => {
        client.store.collections.update(collection.id, {
            shared_properties: sharedProps
        }).then(() => {
            // Handle success
            toast({
                title: t('store.updatedSharedProperties'),
                status: "success"
            });
        }).catch((error) => {
            toast({
                title: t('store.failedToUpdateSharedProperties'),
                description: error.message,
                status: "error"
            });
            // Handle error
        });
    };
    return (_jsx(Panel, { title: t('store.sharedProperties'), description: t('store.sharedPropertiesDescription'), action: _jsx(Button, { size: "lg", isLoading: false, onClick: onSave, children: t('modal.save') }), children: _jsx("div", { className: '', children: _jsx(TagsInput, { value: sharedProps, onChange: onSelect, options: options, placeholder: t('store.selectPropertiesToShare') }) }) }));
}
//# sourceMappingURL=SharedPropsEditor.js.map